<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%">
    <div align="center">
      <p>确定解除费用标准</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">点错了</el-button>
      <el-button type="primary" @click="deleteHousekeepingServFeeConfigRel">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { deleteHousekeepingServFee } from '@/api/housekeeping/housekeepingServFeeApi'

export default {
  name: 'DeleteHousekeepingServFeeConfigRel',
  data() {
    return {
      dialogVisible: false,
      deleteHousekeepingServFeeConfigRelInfo: {}
    }
  },
  methods: {
    open(params) {
      this.dialogVisible = true
      this.deleteHousekeepingServFeeConfigRelInfo = params
    },
    handleClose() {
      this.dialogVisible = false
    },
    deleteHousekeepingServFeeConfigRel() {
      this.deleteHousekeepingServFeeConfigRelInfo.shopId = getShopId()
      deleteHousekeepingServFee(this.deleteHousekeepingServFeeConfigRelInfo)
        .then(res => {
          console.log(res)
          this.$message.success('删除成功')
          this.handleClose()
          this.$emit('refresh')
        })
        .catch(err => {
          this.$message.error(err.msg || '删除失败')
        })
    }
  }
}
</script>